import Constant from '@/const';
import axios from 'axios';

const getLaboratoryById = async id => {
  try {
    const response = await axios.get(
      Constant.apiUrl.concat(`/master/laboratory/${id}`),
    );
    return response;
  } catch (error) {
    this.showErrorAxios(error);
  }
};

export default getLaboratoryById;
